/**
 * Enum Tính BHTN
 * TVDAT 12.07.2022
 */
export default {
  All: -1,
  IsUnemploymentInsurance: 1,
  NotIsUnemploymentInsurance: 0
};
